module.exports = __webpack_public_path__ + "static/media/KIRO.2a0b2715.png";